import { c as _c } from "react/compiler-runtime";
import { PAYMENT__DISCOUNT_SHAPE, PAYMENT__DISCOUNT_SHAPE_DESCRIPTIONS, type PaymentDiscountShape } from '@algoacademy/backend/modules/payment/enums';
import { Description, Field, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Radio, RadioField, RadioGroup } from '@algoacademy/design-system/web/forms/Radio';
import { H4 } from '@algoacademy/design-system/web/typography/Heading';

/**
 * Full price is the third option rather than a switch above the other two, so
 * staff reads all three states in one glance and cannot end up in a half-armed one.
 */
const FULL_PRICE_OPTION = 'full-price';

/** The radio hands back a plain string; this is where it becomes a shape again. */
function readShape(selected: string): PaymentDiscountShape | null {
  if (selected === PAYMENT__DISCOUNT_SHAPE.PERCENT) return PAYMENT__DISCOUNT_SHAPE.PERCENT;
  if (selected === PAYMENT__DISCOUNT_SHAPE.AMOUNT) return PAYMENT__DISCOUNT_SHAPE.AMOUNT;
  return null;
}
type DiscountShapeToggleProps = {
  shape: PaymentDiscountShape | null;
  onChange: (shape: PaymentDiscountShape | null) => void;
};
export function DiscountShapeToggle(t0) {
  const $ = _c(10);
  const {
    shape,
    onChange
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4 className="mb-1.5">Zniżka</H4>;
    t2 = <Description className="text-contentSecondary leading-5!">Zniżka jest naliczana na jeden okres rozliczeniowy, zgodny z częstotliwością subskrypcji wybranej w ofercie.</Description>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = shape ?? FULL_PRICE_OPTION;
  let t4;
  if ($[2] !== onChange) {
    t4 = selected => onChange(readShape(selected));
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RadioField><Radio value={FULL_PRICE_OPTION} aria-label={"Bez zni\u017Cki, cena z cennika"} /><Label>Bez zniżki</Label></RadioField>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <RadioField><Radio value={PAYMENT__DISCOUNT_SHAPE.PERCENT} aria-label={"Zni\u017Cka procentowa od ceny faktury"} /><Label>{PAYMENT__DISCOUNT_SHAPE_DESCRIPTIONS[PAYMENT__DISCOUNT_SHAPE.PERCENT]}</Label></RadioField>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RadioField><Radio value={PAYMENT__DISCOUNT_SHAPE.AMOUNT} aria-label={"Zni\u017Cka kwotowa w z\u0142otych za jeden okres rozliczeniowy"} /><Label>{PAYMENT__DISCOUNT_SHAPE_DESCRIPTIONS[PAYMENT__DISCOUNT_SHAPE.AMOUNT]}</Label></RadioField>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t3 || $[8] !== t4) {
    t8 = <Field>{t1}{t2}<RadioGroup aria-label={"Rodzaj zni\u017Cki"} value={t3} onChange={t4} className="sm:flex sm:flex-row sm:gap-6 sm:space-y-0">{t5}{t6}{t7}</RadioGroup></Field>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}